<template>
    <a v-on:click="saveCourseID" href="javascript:;" data-toggle="modal" data-target="#book-place" class="btn-std btn">
        {{title}}
    </a>
</template>

<script>
    import {mapGetters} from 'vuex';
    import {APP} from 'jsAssets/constants/app';

    export default {
        name: "choose-course-btn",

        props: [
            'title', 'course_id'
        ],

        data() {
            return {

            }
        },

        mounted(){
        },

        methods: {
            /**
             *  При нажатии на кнопку сохраняем ID курса
             *
             * @method addCourseOrderItem
             */
            saveCourseID(){
                this.$store.dispatch('course/getSchema');
                this.$store.commit('course/setChosenCourseID',this.course_id);
            },
        }
    }


</script>
